/*! @pentacode/ui v0.1.0 */
import "./icon-DW8BBY5W.js";
import { t as e } from "./styledElement-DUAqv8gi.js";
import { t } from "./css-build-DcREbovZ.js";
import { measureColumn as n } from "./elements/table/table-autosize.js";
import { t as r } from "./table-cell-renderers-qJCaESvF.js";
import { ColumnDragController as i } from "./elements/table/table-column-drag.js";
import { ColumnStateController as a } from "./elements/table/table-column-state.js";
import "./table-header-menu-BtSc_zGh.js";
import { ResizeController as o } from "./elements/table/table-resize.js";
import { ScrollController as s } from "./elements/table/table-scroll.js";
import { SortController as c } from "./elements/table/table-sort.js";
import { fieldOf as l, getFieldValue as u } from "./elements/table/table.util.js";
import { t as d } from "./decorateMetadata-BXz2gmG4.js";
import { t as f } from "./decorate-C_HUHFGG.js";
import "./elements/table/table-header-renderers.js";
import { LitElement as p, html as m, noChange as h, nothing as g } from "lit";
import { customElement as _, property as v } from "lit/decorators.js";
import { AsyncDirective as y } from "lit/async-directive.js";
import { PartType as b, directive as x } from "lit/directive.js";
import { repeat as S } from "lit/directives/repeat.js";
import { styleMap as C } from "lit/directives/style-map.js";
// ../../node_modules/.pnpm/@lit-labs+virtualizer@2.1.1_patch_hash=c0ed37f982e936d55bce04709503c6d1d9f96a5567353e0dfdd57fdd57dc4562/node_modules/@lit-labs/virtualizer/events.js
var w = class e extends Event {
	constructor(t) {
		super(e.eventName, { bubbles: !1 }), this.first = t.first, this.last = t.last;
	}
};
w.eventName = "rangeChanged";
var T = class e extends Event {
	constructor(t) {
		super(e.eventName, { bubbles: !1 }), this.first = t.first, this.last = t.last;
	}
};
T.eventName = "visibilityChanged";
var E = class e extends Event {
	constructor() {
		super(e.eventName, { bubbles: !1 });
	}
};
E.eventName = "unpinned";
// ../../node_modules/.pnpm/@lit-labs+virtualizer@2.1.1_patch_hash=c0ed37f982e936d55bce04709503c6d1d9f96a5567353e0dfdd57fdd57dc4562/node_modules/@lit-labs/virtualizer/ScrollerController.js
var D = class {
	constructor(e) {
		this._element = null;
		let t = e ?? window;
		this._node = t, e && (this._element = e);
	}
	get element() {
		return this._element || document.scrollingElement || document.documentElement;
	}
	get scrollTop() {
		return this.element.scrollTop || window.scrollY;
	}
	get scrollLeft() {
		return this.element.scrollLeft || window.scrollX;
	}
	get scrollHeight() {
		return this.element.scrollHeight;
	}
	get scrollWidth() {
		return this.element.scrollWidth;
	}
	get viewportHeight() {
		return this._element ? this._element.getBoundingClientRect().height : window.innerHeight;
	}
	get viewportWidth() {
		return this._element ? this._element.getBoundingClientRect().width : window.innerWidth;
	}
	get maxScrollTop() {
		return this.scrollHeight - this.viewportHeight;
	}
	get maxScrollLeft() {
		return this.scrollWidth - this.viewportWidth;
	}
}, O = class extends D {
	constructor(e, t) {
		super(t), this._clients = /* @__PURE__ */ new Set(), this._retarget = null, this._end = null, this.__destination = null, this.correctingScrollError = !1, this._checkForArrival = this._checkForArrival.bind(this), this._updateManagedScrollTo = this._updateManagedScrollTo.bind(this), this.scrollTo = this.scrollTo.bind(this), this.scrollBy = this.scrollBy.bind(this);
		let n = this._node;
		this._originalScrollTo = n.scrollTo, this._originalScrollBy = n.scrollBy, this._originalScroll = n.scroll, this._attach(e);
	}
	get _destination() {
		return this.__destination;
	}
	get scrolling() {
		return this._destination !== null;
	}
	scrollTo(e, t) {
		let n = typeof e == "number" && typeof t == "number" ? {
			left: e,
			top: t
		} : e;
		this._scrollTo(n);
	}
	scrollBy(e, t) {
		let n = typeof e == "number" && typeof t == "number" ? {
			left: e,
			top: t
		} : e;
		n.top !== void 0 && (n.top += this.scrollTop), n.left !== void 0 && (n.left += this.scrollLeft), this._scrollTo(n);
	}
	_nativeScrollTo(e) {
		this._originalScrollTo.bind(this._element || window)(e);
	}
	_scrollTo(e, t = null, n = null) {
		this._end !== null && this._end(), e.behavior === "smooth" ? (this._setDestination(e), this._retarget = t, this._end = n) : this._resetScrollState(), this._nativeScrollTo(e);
	}
	_setDestination(e) {
		let { top: t, left: n } = e;
		return t = t === void 0 ? void 0 : Math.max(0, Math.min(t, this.maxScrollTop)), n = n === void 0 ? void 0 : Math.max(0, Math.min(n, this.maxScrollLeft)), this._destination !== null && n === this._destination.left && t === this._destination.top ? !1 : (this.__destination = {
			top: t,
			left: n,
			behavior: "smooth"
		}, !0);
	}
	_resetScrollState() {
		this.__destination = null, this._retarget = null, this._end = null;
	}
	_updateManagedScrollTo(e) {
		this._destination && this._setDestination(e) && this._nativeScrollTo(this._destination);
	}
	managedScrollTo(e, t, n) {
		return this._scrollTo(e, t, n), this._updateManagedScrollTo;
	}
	correctScrollError(e) {
		this.correctingScrollError = !0, requestAnimationFrame(() => requestAnimationFrame(() => this.correctingScrollError = !1)), this._nativeScrollTo(e), this._retarget && this._setDestination(this._retarget()), this._destination && this._nativeScrollTo(this._destination);
	}
	_checkForArrival() {
		if (this._destination !== null) {
			let { scrollTop: e, scrollLeft: t } = this, { top: n, left: r } = this._destination;
			n = Math.min(n || 0, this.maxScrollTop), r = Math.min(r || 0, this.maxScrollLeft);
			let i = Math.abs(n - e), a = Math.abs(r - t);
			i < 1 && a < 1 && (this._end && this._end(), this._resetScrollState());
		}
	}
	detach(e) {
		return this._clients.delete(e), this._clients.size === 0 && (this._node.scrollTo = this._originalScrollTo, this._node.scrollBy = this._originalScrollBy, this._node.scroll = this._originalScroll, this._node.removeEventListener("scroll", this._checkForArrival)), null;
	}
	_attach(e) {
		this._clients.add(e), this._clients.size === 1 && (this._node.scrollTo = this.scrollTo, this._node.scrollBy = this.scrollBy, this._node.scroll = this.scrollTo, this._node.addEventListener("scroll", this._checkForArrival));
	}
}, k = typeof window < "u" ? window.ResizeObserver : void 0, A = Symbol("virtualizerRef"), j = "virtualizer-sizer", M, N = class {
	constructor(e) {
		if (this._benchmarkStart = null, this._layout = null, this._clippingAncestors = [], this._scrollSize = null, this._scrollError = null, this._childrenPos = null, this._childMeasurements = null, this._toBeMeasured = /* @__PURE__ */ new Map(), this._rangeChanged = !0, this._itemsChanged = !0, this._visibilityChanged = !0, this._scrollerController = null, this._isScroller = !1, this._sizer = null, this._hostElementRO = null, this._childrenRO = null, this._mutationObserver = null, this._scrollEventListeners = [], this._scrollEventListenerOptions = { passive: !0 }, this._loadListener = this._childLoaded.bind(this), this._scrollIntoViewTarget = null, this._updateScrollIntoViewCoordinates = null, this._items = [], this._first = -1, this._last = -1, this._firstVisible = -1, this._lastVisible = -1, this._scheduled = /* @__PURE__ */ new WeakSet(), this._measureCallback = null, this._measureChildOverride = null, this._layoutCompletePromise = null, this._layoutCompleteResolver = null, this._layoutCompleteRejecter = null, this._pendingLayoutComplete = null, this._layoutInitialized = null, this._connected = !1, !e) throw Error("Virtualizer constructor requires a configuration object");
		if (e.hostElement) this._init(e);
		else throw Error("Virtualizer configuration requires the \"hostElement\" property");
	}
	set items(e) {
		Array.isArray(e) && e !== this._items && (this._itemsChanged = !0, this._items = e, this._schedule(this._updateLayout));
	}
	_init(e) {
		this._isScroller = !!e.scroller, this._initHostElement(e);
		let t = e.layout || {};
		this._layoutInitialized = this._initLayout(t);
	}
	_initObservers() {
		this._mutationObserver = new MutationObserver(this._finishDOMUpdate.bind(this)), this._hostElementRO = new k(() => {
			requestAnimationFrame(() => {
				this._connected && this._hostElementSizeChanged();
			});
		}), this._childrenRO = new k((e) => {
			requestAnimationFrame(() => {
				this._connected && this._childrenSizeChanged(e);
			});
		});
	}
	_initHostElement(e) {
		let t = this._hostElement = e.hostElement;
		this._applyVirtualizerStyles(), t[A] = this;
	}
	connected() {
		this._initObservers();
		let e = this._isScroller;
		this._clippingAncestors = R(this._hostElement, e), this._scrollerController = new O(this, this._clippingAncestors[0]), this._schedule(this._updateLayout), this._observeAndListen(), this._connected = !0;
	}
	_observeAndListen() {
		this._mutationObserver.observe(this._hostElement, { childList: !0 }), this._hostElementRO.observe(this._hostElement), this._scrollEventListeners.push(window), window.addEventListener("scroll", this, this._scrollEventListenerOptions), this._clippingAncestors.forEach((e) => {
			e.addEventListener("scroll", this, this._scrollEventListenerOptions), this._scrollEventListeners.push(e), this._hostElementRO.observe(e);
		}), this._hostElementRO.observe(this._scrollerController.element), this._children.forEach((e) => this._childrenRO.observe(e)), this._scrollEventListeners.forEach((e) => e.addEventListener("scroll", this, this._scrollEventListenerOptions));
	}
	disconnected() {
		this._scrollEventListeners.forEach((e) => e.removeEventListener("scroll", this, this._scrollEventListenerOptions)), this._scrollEventListeners = [], this._clippingAncestors = [], this._scrollerController?.detach(this), this._scrollerController = null, this._mutationObserver?.disconnect(), this._mutationObserver = null, this._hostElementRO?.disconnect(), this._hostElementRO = null, this._childrenRO?.disconnect(), this._childrenRO = null, this._rejectLayoutCompletePromise("disconnected"), this._connected = !1;
	}
	_applyVirtualizerStyles() {
		let e = this._hostElement.style;
		e.display = e.display || "block", e.position = e.position || "relative", e.contain = e.contain || "size layout", this._isScroller && (e.overflow = e.overflow || "auto", e.minHeight = e.minHeight || "150px");
	}
	_getSizer() {
		let e = this._hostElement;
		if (!this._sizer) {
			let t = e.querySelector(`[${j}]`);
			t || (t = document.createElement("div"), t.setAttribute(j, ""), e.appendChild(t)), Object.assign(t.style, {
				position: "absolute",
				margin: "-2px 0 0 0",
				padding: 0,
				visibility: "hidden",
				fontSize: "2px"
			}), t.textContent = "&nbsp;", t.setAttribute(j, ""), this._sizer = t;
		}
		return this._sizer;
	}
	async updateLayoutConfig(e) {
		await this._layoutInitialized;
		let t = e.type || M;
		if (typeof t == "function" && this._layout instanceof t) {
			let t = { ...e };
			return delete t.type, this._layout.config = t, !0;
		}
		return !1;
	}
	async _initLayout(e) {
		let t, n;
		if (typeof e.type == "function") {
			n = e.type;
			let r = { ...e };
			delete r.type, t = r;
		} else t = e;
		n === void 0 && (M = n = (await import("./flow-CioHag6y.js")).FlowLayout), this._layout = new n((e) => this._handleLayoutMessage(e), t), this._layout.measureChildren && typeof this._layout.updateItemSizes == "function" && (typeof this._layout.measureChildren == "function" && (this._measureChildOverride = this._layout.measureChildren), this._measureCallback = this._layout.updateItemSizes.bind(this._layout)), this._layout.listenForChildLoadEvents && this._hostElement.addEventListener("load", this._loadListener, !0), this._schedule(this._updateLayout);
	}
	startBenchmarking() {
		this._benchmarkStart === null && (this._benchmarkStart = window.performance.now());
	}
	stopBenchmarking() {
		if (this._benchmarkStart !== null) {
			let e = window.performance.now(), t = e - this._benchmarkStart, n = performance.getEntriesByName("uv-virtualizing", "measure").filter((t) => t.startTime >= this._benchmarkStart && t.startTime < e).reduce((e, t) => e + t.duration, 0);
			return this._benchmarkStart = null, {
				timeElapsed: t,
				virtualizationTime: n
			};
		}
		return null;
	}
	_measureChildren() {
		let e = {}, t = this._children, n = this._measureChildOverride || this._measureChild;
		for (let r = 0; r < t.length; r++) {
			let i = t[r], a = this._first + r;
			(this._itemsChanged || this._toBeMeasured.has(i)) && (e[a] = n.call(this, i, this._items[a]));
		}
		this._childMeasurements = e, this._schedule(this._updateLayout), this._toBeMeasured.clear();
	}
	_measureChild(e) {
		let { width: t, height: n } = e.getBoundingClientRect();
		return Object.assign({
			width: t,
			height: n
		}, P(e));
	}
	async _schedule(e) {
		this._scheduled.has(e) || (this._scheduled.add(e), await Promise.resolve(), this._scheduled.delete(e), e.call(this));
	}
	async _updateDOM(e) {
		this._scrollSize = e.scrollSize, this._adjustRange(e.range), this._childrenPos = e.childPositions, this._scrollError = e.scrollError || null;
		let { _rangeChanged: t, _itemsChanged: n } = this;
		this._visibilityChanged &&= (this._notifyVisibility(), !1), (t || n) && (this._notifyRange(), this._rangeChanged = !1), this._finishDOMUpdate();
	}
	_finishDOMUpdate() {
		this._connected && (this._children.forEach((e) => this._childrenRO.observe(e)), this._checkScrollIntoViewTarget(this._childrenPos), this._positionChildren(this._childrenPos), this._sizeHostElement(this._scrollSize), this._correctScrollError(), this._benchmarkStart && "mark" in window.performance && window.performance.mark("uv-end"));
	}
	_updateLayout() {
		this._layout && this._connected && (this._layout.items = this._items, this._updateView(), this._childMeasurements !== null && (this._measureCallback && this._measureCallback(this._childMeasurements), this._childMeasurements = null), this._layout.reflowIfNeeded(), this._benchmarkStart && "mark" in window.performance && window.performance.mark("uv-end"));
	}
	_handleScrollEvent() {
		if (this._benchmarkStart && "mark" in window.performance) {
			try {
				window.performance.measure("uv-virtualizing", "uv-start", "uv-end");
			} catch (e) {
				console.warn("Error measuring performance data: ", e);
			}
			window.performance.mark("uv-start");
		}
		this._scrollerController.correctingScrollError === !1 && this._layout?.unpin(), this._schedule(this._updateLayout);
	}
	handleEvent(e) {
		switch (e.type) {
			case "scroll":
				(e.currentTarget === window || this._clippingAncestors.includes(e.currentTarget)) && this._handleScrollEvent();
				break;
			default: console.warn("event not handled", e);
		}
	}
	_handleLayoutMessage(e) {
		e.type === "stateChanged" ? this._updateDOM(e) : e.type === "visibilityChanged" ? (this._firstVisible = e.firstVisible, this._lastVisible = e.lastVisible, this._notifyVisibility()) : e.type === "unpinned" && this._hostElement.dispatchEvent(new E());
	}
	get _children() {
		let e = [], t = this._hostElement.firstElementChild;
		for (; t;) t.hasAttribute(j) || e.push(t), t = t.nextElementSibling;
		return e;
	}
	_updateView() {
		let e = this._hostElement, t = this._scrollerController?.element, n = this._layout;
		if (e && t && n) {
			let r, i, a, o, s = e.getBoundingClientRect();
			r = 0, i = 0, a = window.innerHeight, o = window.innerWidth;
			let c = this._clippingAncestors.map((e) => e.getBoundingClientRect());
			c.unshift(s);
			for (let e of c) r = Math.max(r, e.top), i = Math.max(i, e.left), a = Math.min(a, e.bottom), o = Math.min(o, e.right);
			let l = t.getBoundingClientRect(), u = {
				left: s.left - l.left,
				top: s.top - l.top
			}, d = {
				width: t.scrollWidth,
				height: t.scrollHeight
			}, f = r - s.top + e.scrollTop, p = i - s.left + e.scrollLeft, m = Math.max(0, a - r);
			n.viewportSize = {
				width: Math.max(0, o - i),
				height: m
			}, n.viewportScroll = {
				top: f,
				left: p
			}, n.totalScrollSize = d, n.offsetWithinScroller = u;
		}
	}
	_sizeHostElement(e) {
		let t = 82e5, n = e && e.width !== null ? Math.min(t, e.width) : 0, r = e && e.height !== null ? Math.min(t, e.height) : 0;
		if (this._isScroller) this._getSizer().style.transform = `translate(${n}px, ${r}px)`;
		else {
			let e = this._hostElement.style;
			e.minWidth = n ? `${n}px` : "100%", e.minHeight = r ? `${r}px` : "100%";
		}
	}
	_positionChildren(e) {
		e && e.forEach(({ top: e, left: t, width: n, height: r, xOffset: i, yOffset: a }, o) => {
			let s = this._children[o - this._first];
			s && (s.style.position = "absolute", s.style.boxSizing = "border-box", s.style.transform = `translate(${t}px, ${e}px)`, n !== void 0 && (s.style.width = n + "px"), r !== void 0 && (s.style.height = r + "px"), s.style.left = i === void 0 ? null : i + "px", s.style.top = a === void 0 ? null : a + "px");
		});
	}
	async _adjustRange(e) {
		let { _first: t, _last: n, _firstVisible: r, _lastVisible: i } = this;
		this._first = e.first, this._last = e.last, this._firstVisible = e.firstVisible, this._lastVisible = e.lastVisible, this._rangeChanged = this._rangeChanged || this._first !== t || this._last !== n, this._visibilityChanged = this._visibilityChanged || this._firstVisible !== r || this._lastVisible !== i;
	}
	_correctScrollError() {
		if (this._scrollError) {
			let { scrollTop: e, scrollLeft: t } = this._scrollerController, { top: n, left: r } = this._scrollError;
			this._scrollError = null, this._scrollerController.correctScrollError({
				top: e - n,
				left: t - r
			});
		}
	}
	element(e) {
		return e === Infinity && (e = this._items.length - 1), this._items?.[e] === void 0 ? void 0 : { scrollIntoView: (t = {}) => this._scrollElementIntoView({
			...t,
			index: e
		}) };
	}
	_scrollElementIntoView(e) {
		if (e.index >= this._first && e.index <= this._last) this._children[e.index - this._first].scrollIntoView(e);
		else if (e.index = Math.min(e.index, this._items.length - 1), e.behavior === "smooth") {
			let t = this._layout.getScrollIntoViewCoordinates(e), { behavior: n } = e;
			this._updateScrollIntoViewCoordinates = this._scrollerController.managedScrollTo(Object.assign(t, { behavior: n }), () => this._layout.getScrollIntoViewCoordinates(e), () => this._scrollIntoViewTarget = null), this._scrollIntoViewTarget = e;
		} else this._layout.pin = e;
	}
	_checkScrollIntoViewTarget(e) {
		let { index: t } = this._scrollIntoViewTarget || {};
		t && e?.has(t) && this._updateScrollIntoViewCoordinates(this._layout.getScrollIntoViewCoordinates(this._scrollIntoViewTarget));
	}
	_notifyRange() {
		this._hostElement.dispatchEvent(new w({
			first: this._first,
			last: this._last
		}));
	}
	_notifyVisibility() {
		this._hostElement.dispatchEvent(new T({
			first: this._firstVisible,
			last: this._lastVisible
		}));
	}
	get layoutComplete() {
		return this._layoutCompletePromise ||= new Promise((e, t) => {
			this._layoutCompleteResolver = e, this._layoutCompleteRejecter = t;
		}), this._layoutCompletePromise;
	}
	_rejectLayoutCompletePromise(e) {
		this._layoutCompleteRejecter !== null && this._layoutCompleteRejecter(e), this._resetLayoutCompleteState();
	}
	_scheduleLayoutComplete() {
		this._layoutCompletePromise && this._pendingLayoutComplete === null && (this._pendingLayoutComplete = requestAnimationFrame(() => requestAnimationFrame(() => this._resolveLayoutCompletePromise())));
	}
	_resolveLayoutCompletePromise() {
		this._layoutCompleteResolver !== null && this._layoutCompleteResolver(), this._resetLayoutCompleteState();
	}
	_resetLayoutCompleteState() {
		this._layoutCompletePromise = null, this._layoutCompleteResolver = null, this._layoutCompleteRejecter = null, this._pendingLayoutComplete = null;
	}
	_hostElementSizeChanged() {
		this._schedule(this._updateLayout);
	}
	_childLoaded() {}
	_childrenSizeChanged(e) {
		if (this._layout?.measureChildren) {
			for (let t of e) this._toBeMeasured.set(t.target, t.contentRect);
			this._measureChildren();
		}
		this._scheduleLayoutComplete(), this._itemsChanged = !1, this._rangeChanged = !1;
	}
};
function P(e) {
	let t = window.getComputedStyle(e);
	return {
		marginTop: F(t.marginTop),
		marginRight: F(t.marginRight),
		marginBottom: F(t.marginBottom),
		marginLeft: F(t.marginLeft)
	};
}
function F(e) {
	let t = e ? parseFloat(e) : NaN;
	return Number.isNaN(t) ? 0 : t;
}
function I(e) {
	if (e.assignedSlot !== null) return e.assignedSlot;
	if (e.parentElement !== null) return e.parentElement;
	let t = e.parentNode;
	return t && t.nodeType === Node.DOCUMENT_FRAGMENT_NODE && t.host || null;
}
function L(e, t = !1) {
	let n = [], r = t ? e : I(e);
	for (; r !== null;) n.push(r), r = I(r);
	return n;
}
function R(e, t = !1) {
	let n = !1;
	return L(e, t).filter((e) => {
		if (n) return !1;
		let t = getComputedStyle(e);
		return n = t.position === "fixed", t.overflow !== "visible";
	});
}
// ../../node_modules/.pnpm/@lit-labs+virtualizer@2.1.1_patch_hash=c0ed37f982e936d55bce04709503c6d1d9f96a5567353e0dfdd57fdd57dc4562/node_modules/@lit-labs/virtualizer/virtualize.js
var z = (e) => e, B = (e, t) => m`${t}: ${JSON.stringify(e, null, 2)}`, V = x(class extends y {
	constructor(e) {
		if (super(e), this._virtualizer = null, this._first = 0, this._last = -1, this._renderItem = (e, t) => B(e, t + this._first), this._keyFunction = (e, t) => z(e, t + this._first), this._items = [], e.type !== b.CHILD) throw Error("The virtualize directive can only be used in child expressions");
	}
	render(e) {
		e && this._setFunctions(e);
		let t = [];
		if (this._first >= 0 && this._last >= this._first) for (let e = this._first; e <= this._last; e++) t.push(this._items[e]);
		return S(t, this._keyFunction, this._renderItem);
	}
	update(e, [t]) {
		this._setFunctions(t);
		let n = this._items !== t.items;
		return this._items = t.items || [], this._virtualizer ? this._updateVirtualizerConfig(e, t) : this._initialize(e, t), n ? h : this.render();
	}
	async _updateVirtualizerConfig(e, t) {
		if (!await this._virtualizer.updateLayoutConfig(t.layout || {})) {
			let n = e.parentNode;
			this._makeVirtualizer(n, t);
		}
		this._virtualizer.items = this._items;
	}
	_setFunctions(e) {
		let { renderItem: t, keyFunction: n } = e;
		t && (this._renderItem = (e, n) => t(e, n + this._first)), n && (this._keyFunction = (e, t) => n(e, t + this._first));
	}
	_makeVirtualizer(e, t) {
		this._virtualizer && this._virtualizer.disconnected();
		let { layout: n, scroller: r, items: i } = t;
		this._virtualizer = new N({
			hostElement: e,
			layout: n,
			scroller: r
		}), this._virtualizer.items = i, this._virtualizer.connected();
	}
	_initialize(e, t) {
		let n = e.parentNode;
		n && n.nodeType === 1 && (n.addEventListener("rangeChanged", (e) => {
			this._first = e.first, this._last = e.last, this.setValue(this.render());
		}), this._makeVirtualizer(n, t));
	}
	disconnected() {
		this._virtualizer?.disconnected();
	}
	reconnected() {
		this._virtualizer?.connected();
	}
}), H = t(":host{--wa-font-size-scale:.875;--wa-font-size-m:14px;width:100%;font-size:var(--wa-font-size-m);--ptc-ui-table-row-height:2.25em;--ptc-ui-table-header-row-height:var(--ptc-ui-table-row-height);--ptc-ui-table-columns:repeat(auto-fill, minmax(100px, 1fr));--ptc-ui-table-cell-padding:.35em .5em;--ptc-ui-table-border-color:oklch(from var(--color-neutral) 90% c h);--ptc-ui-table-border-width:1px;--ptc-ui-table-body-min-height:15em;--ptc-ui-table-row-highlight:#0000000a;--ptc-ui-table-column-highlight:#0000000a;--ptc-ui-table-radius:var(--radius);--ptc-ui-table-shadow-color:#00000014;--ptc-ui-table-shadow-size:8px;--ptc-ui-table-accent-color:var(--color-primary,#2185d0);--ptc-ui-table-accent-glow:color-mix(in srgb, var(--ptc-ui-table-accent-color) 18%, transparent);--ptc-ui-table-header-gap:.25em;--ptc-ui-table-drag-opacity:.3;--ptc-ui-table-drop-indicator-width:3px;--ptc-ui-table-transition-speed:.2s;--ptc-ui-table-scrollbar-size:8px;--_ui-table-scrollbar-color:var(--ptc-ui-table-scrollbar-color,var(--ptc-ui-table-border-color));--_ui-table-scrollbar-thumb-inset:calc(var(--ptc-ui-table-scrollbar-size) / 4);--_ui-table-scrollbar-thumb-radius:calc(var(--ptc-ui-table-scrollbar-size) / 2);display:block;position:relative}table{border-collapse:collapse;grid-template-rows:var(--ptc-ui-table-header-row-height) auto;outline:calc(var(--ptc-ui-table-border-width) + .5px) solid var(--ptc-ui-table-border-color);border-radius:var(--ptc-ui-table-radius);outline-offset:calc(-1 * var(--ptc-ui-table-border-width));background:var(--ptc-ui-table-bg,var(--color-bg,white));width:100%;height:100%;display:grid;position:relative}tr{grid-template-columns:var(--ptc-ui-table-columns);height:var(--ptc-ui-table-row-height);width:100%;min-width:max-content;display:grid}thead tr{height:var(--ptc-ui-table-header-row-height)}td,th{padding:var(--ptc-ui-table-cell-padding);box-shadow:inset calc(-1 * var(--ptc-ui-table-border-width)) 0 0 var(--ptc-ui-table-border-color), inset 0 calc(-1 * var(--ptc-ui-table-border-width)) 0 var(--ptc-ui-table-border-color);height:inherit;box-sizing:border-box;place-content:center start;display:grid}:is(td,th):has(.cell-fill){padding:0}.cell-fill{width:100%;height:100%;padding:var(--ptc-ui-table-cell-padding)}.cell-badge{border-radius:1em;padding:.1em .5em;font-size:.85em;line-height:1.4;display:inline-block}.cell-badge--filled{background:var(--badge-color);color:#fff}.cell-badge--outline{color:var(--badge-color);border:1px solid var(--badge-color);background:0 0}.cell-link{color:var(--ptc-ui-table-accent-color);text-decoration:none}"), U = t("th.dragging{opacity:var(--ptc-ui-table-drag-opacity)}th.drop-before{position:relative}th.drop-before:before{content:\"\";left:calc(-.5 * var(--ptc-ui-table-drop-indicator-width));width:var(--ptc-ui-table-drop-indicator-width);background:var(--ptc-ui-table-accent-color);z-index:5;border-radius:2px;position:absolute;top:0;bottom:0}th.drop-after{position:relative}th.drop-after:after{content:\"\";right:calc(-.5 * var(--ptc-ui-table-drop-indicator-width));width:var(--ptc-ui-table-drop-indicator-width);background:var(--ptc-ui-table-accent-color);z-index:5;border-radius:2px;position:absolute;top:0;bottom:0}.pin-zone{pointer-events:none;z-index:-1;opacity:0;width:60px;transition:opacity .3s ease, display .3s ease allow-discrete;display:none;position:absolute;top:0;bottom:0}.pin-zone.pin-zone-left{background:linear-gradient(to right, var(--ptc-ui-table-accent-glow), transparent);border-radius:var(--ptc-ui-table-radius) 0 0 var(--ptc-ui-table-radius);left:0}.pin-zone.pin-zone-right{background:linear-gradient(to left, var(--ptc-ui-table-accent-glow), transparent);border-radius:0 var(--ptc-ui-table-radius) var(--ptc-ui-table-radius) 0;right:0}.pin-zone.active{opacity:1;display:block}@starting-style{.pin-zone.active{opacity:0}}.pin-group-glow{pointer-events:none;z-index:1;opacity:0;width:40px;transition:opacity .3s ease, display .3s ease allow-discrete;display:none;position:absolute;top:0;bottom:0}.pin-group-glow.pin-group-glow-left{background:linear-gradient(to right, var(--ptc-ui-table-accent-glow), transparent)}.pin-group-glow.pin-group-glow-right{background:linear-gradient(to left, var(--ptc-ui-table-accent-glow), transparent)}.pin-group-glow.active{opacity:1;display:block}@starting-style{.pin-group-glow.active{opacity:0}}"), W = t("th.header-cell{vertical-align:bottom;text-align:start;place-content:end start;position:relative;overflow:hidden}.header-cell-content{align-items:center;gap:var(--ptc-ui-table-header-gap);display:flex}th.header-cell.vertical-header-down{vertical-align:top;place-content:start}.vertical-header-label{white-space:nowrap;align-items:center;gap:.4em;display:inline-flex}th.vertical-header-down .vertical-header-label{writing-mode:vertical-rl}th.vertical-header-up .vertical-header-label{writing-mode:sideways-lr}.resize-handle{cursor:col-resize;z-index:3;touch-action:none;width:5px;position:absolute;top:0;bottom:0;right:-2px}.resize-handle:after{content:\"\";background:var(--ptc-ui-table-border-color);opacity:0;width:1px;transition:opacity .15s;position:absolute;top:25%;bottom:25%;right:2px}.resize-handle:hover:after{opacity:1;background:var(--ptc-ui-table-accent-color)}.header-label{text-overflow:ellipsis;white-space:nowrap;flex:1;min-width:0;overflow:hidden}.sort-indicator{opacity:.6;flex-shrink:0;align-items:center;gap:.1em;font-size:.7em;display:inline-flex}.sort-order{align-self:flex-end;font-size:.75em;font-weight:600;line-height:1}th.sortable{cursor:pointer;-webkit-user-select:none;user-select:none}.header-menu-trigger{opacity:0;cursor:pointer;color:inherit;background:0 0;border:none;border-radius:3px;flex-shrink:0;padding:.15em .3em;font-size:.85em;line-height:1;transition:opacity .15s,background .15s}th:hover .header-menu-trigger,.header-menu-trigger:focus-visible{opacity:.6}.header-menu-trigger:hover{opacity:1;background:#00000014}"), G = t(":host([highlight-row]) tbody tr:hover td{background-color:var(--ptc-ui-table-row-highlight)}:host([highlight-column]) table{overflow:hidden}:host([highlight-column]) td,:host([highlight-column]) th{position:relative}:host([highlight-column]) td:hover:after{content:\"\";background-color:var(--ptc-ui-table-column-highlight);pointer-events:none;z-index:-1;inset-inline:0;height:10000px;position:absolute;top:-5000px}"), K = t(":host([native]){border-radius:var(--ptc-ui-table-radius);border:calc(var(--ptc-ui-table-border-width) + .5px) solid var(--ptc-ui-table-border-color);background:var(--ptc-ui-table-bg,var(--color-bg,white));overflow:hidden}:host([native]) .native-scroller{border-radius:var(--ptc-ui-table-radius);width:100%;height:calc(100% + 2px);font-size:0;display:block;position:relative;overflow:auto}:host([native]) table,:host([native]) thead,:host([native]) tbody,:host([native]) tr,:host([native]) th,:host([native]) td{display:revert}:host([native]) table{border-collapse:separate;border-spacing:0;table-layout:auto;background:var(--ptc-ui-table-bg,var(--color-bg,white));vertical-align:top;width:max-content;height:calc(100% - 2px);font-size:var(--wa-font-size-m);border-radius:0;outline:none;margin:0;display:table}:host([native]) thead{clip-path:none;overflow:visible}:host([native]) tbody{clip-path:none;border-radius:0;outline:none;overflow:visible;min-height:0!important}:host([native]) th,:host([native]) td{height:auto;box-shadow:none;border-right:var(--ptc-ui-table-border-width) solid var(--ptc-ui-table-border-color);border-bottom:var(--ptc-ui-table-border-width) solid var(--ptc-ui-table-border-color);background:var(--ptc-ui-table-bg,var(--color-bg,white))}:host([native]) tr:last-child td{border-bottom:none}:host([native]) th:last-child,:host([native]) td:last-child{border-right:none}:host([native]) thead th{z-index:2;background:var(--ptc-ui-table-header-bg,var(--color-bg-subtle,var(--color-bg,white)));position:sticky;top:0}:host([native]) th[data-pinned],:host([native]) td[data-pinned]{z-index:1;background:var(--ptc-ui-table-pinned-bg,var(--ptc-ui-table-bg,var(--color-bg,white)));position:sticky}:host([native]) thead th[data-pinned]{z-index:3;background:var(--ptc-ui-table-header-bg,var(--color-bg-subtle,var(--color-bg,white)))}:host([native]) [data-pinned=left][data-pin-edge]{box-shadow:inset calc(-1 * var(--ptc-ui-table-border-width)) 0 0 var(--ptc-ui-table-border-color)}:host([native]) [data-pinned=right][data-pin-edge]{box-shadow:inset var(--ptc-ui-table-border-width) 0 0 var(--ptc-ui-table-border-color)}:host([native]) .header-cell-content{align-items:center;gap:var(--ptc-ui-table-header-gap);display:flex}:host([native]) .resize-handle{display:none}"), q = t(".pinned-group{z-index:1;background:var(--ptc-ui-table-pinned-bg,var(--color-bg,white));height:inherit;display:flex;position:sticky}.pinned-group.pinned-group-left{left:0}.pinned-group.pinned-group-right{right:0}.pinned-shadow{top:0;bottom:var(--_scrollbar-height,0px);width:var(--ptc-ui-table-shadow-size);pointer-events:none;opacity:0;z-index:3;transition:opacity var(--ptc-ui-table-transition-speed) ease, translate var(--ptc-ui-table-transition-speed) ease;position:absolute}.pinned-shadow.pinned-shadow-left{background:linear-gradient(to right, var(--ptc-ui-table-shadow-color), transparent);translate:-4px}:host([pinned-left-shadow]) .pinned-shadow.pinned-shadow-left{opacity:1;translate:0}.pinned-shadow.pinned-shadow-right{background:linear-gradient(to left, var(--ptc-ui-table-shadow-color), transparent);translate:4px}:host([pinned-right-shadow]) .pinned-shadow.pinned-shadow-right{opacity:1;translate:0}"), J = t("thead{overflow-x:hidden;overflow-y:var(--_scrollbar-header-overflow,auto);clip-path:xywh(var(--ptc-ui-table-border-width) var(--ptc-ui-table-border-width) calc(100% - var(--ptc-ui-table-border-width) * 2) 100% round var(--ptc-ui-table-radius) var(--ptc-ui-table-radius) 0 0)}thead .pinned-group{z-index:2}tbody{width:100%;clip-path:xywh(var(--ptc-ui-table-border-width) 0 calc(100% - var(--ptc-ui-table-border-width) * 2) calc(100% - var(--ptc-ui-table-border-width)) round 0 0 calc(var(--ptc-ui-table-radius) - var(--ptc-ui-table-border-width)) calc(var(--ptc-ui-table-radius) - var(--ptc-ui-table-border-width)));outline:var(--ptc-ui-table-border-width) solid var(--ptc-ui-table-border-color);outline-offset:0px;border-radius:0 0 var(--ptc-ui-table-radius) var(--ptc-ui-table-radius);overflow:auto;min-height:var(--ptc-ui-table-body-min-height)!important}@supports not selector(::-webkit-scrollbar){thead,tbody,.native-scroller{scrollbar-width:thin;scrollbar-color:var(--_ui-table-scrollbar-color) var(--ptc-ui-table-bg,var(--color-bg,white))}}thead::-webkit-scrollbar{-webkit-appearance:none;width:var(--ptc-ui-table-scrollbar-size);height:var(--ptc-ui-table-scrollbar-size)}tbody::-webkit-scrollbar{-webkit-appearance:none;width:var(--ptc-ui-table-scrollbar-size);height:var(--ptc-ui-table-scrollbar-size)}.native-scroller::-webkit-scrollbar{-webkit-appearance:none;width:var(--ptc-ui-table-scrollbar-size);height:var(--ptc-ui-table-scrollbar-size)}thead::-webkit-scrollbar-track{background:var(--ptc-ui-table-bg,var(--color-bg,white))}tbody::-webkit-scrollbar-track{background:var(--ptc-ui-table-bg,var(--color-bg,white))}.native-scroller::-webkit-scrollbar-track{background:var(--ptc-ui-table-bg,var(--color-bg,white))}thead::-webkit-scrollbar-thumb{background:var(--_ui-table-scrollbar-color);border:var(--_ui-table-scrollbar-thumb-inset) solid transparent;border-radius:var(--_ui-table-scrollbar-thumb-radius);background-clip:padding-box}tbody::-webkit-scrollbar-thumb{background:var(--_ui-table-scrollbar-color);border:var(--_ui-table-scrollbar-thumb-inset) solid transparent;border-radius:var(--_ui-table-scrollbar-thumb-radius);background-clip:padding-box}.native-scroller::-webkit-scrollbar-thumb{background:var(--_ui-table-scrollbar-color);border:var(--_ui-table-scrollbar-thumb-inset) solid transparent;border-radius:var(--_ui-table-scrollbar-thumb-radius);background-clip:padding-box}thead::-webkit-scrollbar-thumb:hover{background:var(--_ui-table-scrollbar-color-hover,#00000080);background-clip:padding-box}tbody::-webkit-scrollbar-thumb:hover{background:var(--_ui-table-scrollbar-color-hover,#00000080);background-clip:padding-box}.native-scroller::-webkit-scrollbar-thumb:hover{background:var(--_ui-table-scrollbar-color-hover,#00000080);background-clip:padding-box}thead::-webkit-scrollbar-corner{background:var(--ptc-ui-table-bg,var(--color-bg,white))}tbody::-webkit-scrollbar-corner{background:var(--ptc-ui-table-bg,var(--color-bg,white))}.native-scroller::-webkit-scrollbar-corner{background:var(--ptc-ui-table-bg,var(--color-bg,white))}.scroll-shadow{left:0;right:var(--_scrollbar-width,0px);height:var(--ptc-ui-table-shadow-size);pointer-events:none;opacity:0;z-index:3;transition:opacity var(--ptc-ui-table-transition-speed) ease, translate var(--ptc-ui-table-transition-speed) ease;position:absolute}.scroll-shadow.scroll-shadow-top{top:var(--ptc-ui-table-row-height);background:linear-gradient(to bottom, var(--ptc-ui-table-shadow-color), transparent);translate:0 -4px}:host([scroll-top-shadow]) .scroll-shadow.scroll-shadow-top{opacity:1;translate:0}.scroll-shadow.scroll-shadow-bottom{bottom:var(--_scrollbar-height,0px);background:linear-gradient(to top, var(--ptc-ui-table-shadow-color), transparent);border-radius:0 0 var(--_scroll-shadow-bottom-right-radius,var(--ptc-ui-table-radius)) var(--_scroll-shadow-bottom-left-radius,var(--ptc-ui-table-radius));translate:0 4px}:host([scroll-bottom-shadow]) .scroll-shadow.scroll-shadow-bottom{opacity:1;translate:0}"), Y = class extends e(p) {
	constructor(...e) {
		super(...e), this.styles = [
			H,
			W,
			q,
			J,
			U,
			G,
			K
		], this.columnDefs = [], this.rowData = [], this.virtualization = {
			enableX: !1,
			enableY: !1,
			rowHeight: 32,
			overscan: 5
		}, this.headerHeight = 32, this.showBorders = !0, this.striped = !1, this.rowIdField = "id", this.pinIndex = -1, this.virtualized = !0, this.native = !1, this.scrollShadows = !1, this.highlightRow = !1, this.highlightColumn = !1, this.movableColumns = !0, this.sortState = [], this._sort = new c(this), this._resize = new o(this), this._columns = new a(this), this._drag = new i(this), this._scroll = new s(this), this._stickyWidths = /* @__PURE__ */ new Map(), this._stickyObserved = /* @__PURE__ */ new Set(), this._stickySyncRaf = 0, this._renderRow = (e, t, n, r) => this.native ? m`<tr>
                ${n.all.map((n) => {
			let i = l(n);
			return this._renderCell(e, t, n, r?.offsets.get(i), r?.edgeField.has(i));
		})}
            </tr>` : m`<tr>
            ${this._renderPinnedGroup("left", n.left, e, t)}
            ${n.center.map((n) => this._renderCell(e, t, n))}
            ${this._renderPinnedGroup("right", n.right, e, t)}
        </tr>`, this._renderCell = (e, t, n, i, a) => {
			let o = n.valueGetter ? n.valueGetter({
				data: e,
				column: n,
				getValue: (t) => u(e, t)
			}) : u(e, l(n)), s = this._getColumnStyle(n, i), c = n.pinned ?? g, d = a ? "" : g, f = {
				value: o,
				data: e,
				rowIndex: t,
				column: n
			};
			if (n.cellRenderer) return m`<td
                data-field=${l(n)}
                data-pinned=${c}
                data-pin-edge=${d}
                style=${C(s)}
            >
                ${n.cellRenderer(f)}
            </td>`;
			if (n.type) {
				let e = r(n.type);
				if (e) return m`<td
                    data-field=${l(n)}
                    data-pinned=${c}
                    data-pin-edge=${d}
                    style=${C(s)}
                >
                    ${e(f, n.typeOptions ?? {})}
                </td>`;
			}
			return m`<td
            data-field=${l(n)}
            data-pinned=${c}
            data-pin-edge=${d}
            style=${C(s)}
        >
            ${o ?? ""}
        </td>`;
		};
	}
	getSourceColumns() {
		return this._columns.columnOrder ?? this.columnDefs;
	}
	willUpdate(e) {
		e.has("sortState") && this._sort.setStates(this.sortState ?? []), e.has("columnDefs") && this._columns.reset();
	}
	updated() {
		this._scroll.hostUpdated(), this.native && this._scheduleStickySync();
	}
	firstUpdated() {
		this._scroll.initElements();
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this._stickyResizeObs?.disconnect(), this._stickyResizeObs = void 0, this._stickyObserved.clear(), this._stickySyncRaf && cancelAnimationFrame(this._stickySyncRaf), this._stickySyncRaf = 0;
	}
	_syncStickyMeasurements() {
		let e = this.renderRoot.querySelectorAll("thead th[data-pinned]"), t = this._stickyResizeObs ??= new ResizeObserver(() => this._scheduleStickySync()), n = !1, r = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set();
		for (let a of e) {
			let e = a.dataset.field;
			if (!e) continue;
			r.add(e), i.add(a);
			let o = Math.round(a.getBoundingClientRect().width);
			this._stickyWidths.get(e) !== o && (this._stickyWidths.set(e, o), n = !0), this._stickyObserved.has(a) || t.observe(a);
		}
		for (let e of this._stickyObserved) i.has(e) || t.unobserve(e);
		this._stickyObserved = i;
		for (let e of this._stickyWidths.keys()) r.has(e) || (this._stickyWidths.delete(e), n = !0);
		n && this.requestUpdate();
	}
	_scheduleStickySync() {
		this._stickySyncRaf ||= requestAnimationFrame(() => {
			this._stickySyncRaf = 0, this.native && this._syncStickyMeasurements();
		});
	}
	autosizeColumn(e, t) {
		let r = n(this.renderRoot, e, t);
		if (r > 0) {
			let t = this.getSourceColumns().find((t) => l(t) === e), n = t?.minWidth ?? 40, i = t?.maxWidth ?? Infinity;
			this._resize.setWidth(e, Math.round(Math.min(i, Math.max(n, r + 2))));
		}
	}
	autosizeAllColumns(e) {
		for (let t of this.getSourceColumns()) t.hide || this.autosizeColumn(l(t), e);
	}
	_computeStickyLayout(e, t) {
		let n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), i = (e) => {
			let t = l(e);
			return this._stickyWidths.get(t) ?? this._resize.getWidth(e) ?? e.minWidth ?? 0;
		}, a = 0;
		for (let t of e) n.set(l(t), a), a += i(t);
		e.length > 0 && r.add(l(e[e.length - 1]));
		let o = 0;
		for (let e of [...t].reverse()) n.set(l(e), o), o += i(e);
		return t.length > 0 && r.add(l(t[0])), {
			offsets: n,
			edgeField: r
		};
	}
	_getColumnStyle(e, t) {
		let n = {}, r = this._resize.getWidth(e);
		return r != null && (n.width = `${r}px`), e.minWidth != null && (n.minWidth = `${e.minWidth}px`), e.maxWidth != null && (n.maxWidth = `${e.maxWidth}px`), this.native && t != null && e.pinned && (n[e.pinned] = `${t}px`), n;
	}
	_handleMenuSelect(e, t) {
		switch (e) {
			case "sort-asc":
				this._sort.handleMenuSort("asc", t);
				break;
			case "sort-desc":
				this._sort.handleMenuSort("desc", t);
				break;
			case "pin-left":
				this._columns.requestPinChange(t, "left");
				break;
			case "pin-right":
				this._columns.requestPinChange(t, "right");
				break;
			case "autosize":
				this.autosizeColumn(l(t));
				break;
			case "autosize-all": this.autosizeAllColumns();
		}
	}
	_renderPinnedGroup(e, t, n, r) {
		return t.length === 0 ? g : m`<div class="pinned-group pinned-group-${e}" style="grid-column: span ${t.length}">
            ${t.map((e) => this._renderCell(n, r, e))}
        </div>`;
	}
	_isColumnMovable(e) {
		return this.movableColumns && e.movable !== !1;
	}
	_renderHeaderCell(e, t, n) {
		let r = l(e), i = this._sort.getEntry(r), a = i?.state.direction ?? null, o = this._sort.states.length > 1 && i, { isDragging: s, draggedField: c, dropTargetField: u, dropPosition: d } = this._drag.state, f = s && u === r ? `drop-${d}` : "";
		return m`<th
            part="header-cell ${e.headerClass || ""}"
            class="header-cell ${e.headerClass || ""} ${s && c === r ? "dragging" : ""} ${f} ${e.sortable ? "sortable" : ""}"
            style=${C(this._getColumnStyle(e, t))}
            data-field=${r}
            data-pinned=${e.pinned ?? g}
            data-pin-edge=${n ? "" : g}
            aria-sort=${a === "asc" ? "ascending" : a === "desc" ? "descending" : "none"}
            @pointerdown=${this._isColumnMovable(e) ? (e) => this._drag.handlePointerDown(e, r) : g}
            @click=${e.sortable ? (t) => this._sort.handleHeaderClick(t, e) : g}
        >
            <div class="header-cell-content">
                ${e.headerRenderer ? e.headerRenderer({ column: e }) : m`<span class="header-label">${e.headerName}</span>`}
                ${a ? m`<span class="sort-indicator">
                          ${a === "asc" ? m`<ptc-ui-icon name="icon.action.sort-ascending:active"></ptc-ui-icon>` : m`<ptc-ui-icon name="icon.action.sort-descending:active"></ptc-ui-icon>`}
                          ${o ? m`<span class="sort-order">${i.index + 1}</span>` : g}
                      </span>` : g}
                ${e.headerMenu === !1 ? g : m`<ptc-ui-table-header-menu
                          .column=${e}
                          ?native=${this.native}
                          @menu-select=${(t) => this._handleMenuSelect(t.detail.value, e)}
                      ></ptc-ui-table-header-menu>`}
            </div>
            ${e.resizable !== !1 && !this.native ? m`<div
                      class="resize-handle"
                      @pointerdown=${(t) => this._resize.handleResizeStart(t, e)}
                  ></div>` : g}
        </th>`;
	}
	_renderHeaderPinnedGroup(e, t) {
		return t.length === 0 ? g : m`<div class="pinned-group pinned-group-${e}" style="grid-column: span ${t.length}">
            ${t.map((e) => this._renderHeaderCell(e))}
        </div>`;
	}
	_renderOverlays(e, t) {
		let n = this._scroll.scrollbarWidth, r = this._drag.state;
		return m`
            ${this.scrollShadows && e > 0 ? m`<div class="pinned-shadow pinned-shadow-left" style="left: ${e}px"></div>` : g}
            ${this.scrollShadows && t > 0 ? m`<div
                      class="pinned-shadow pinned-shadow-right"
                      style="right: ${t + n}px"
                  ></div>` : g}
            ${this.scrollShadows ? m`<div class="scroll-shadow scroll-shadow-top"></div>
                      <div class="scroll-shadow scroll-shadow-bottom"></div>` : g}
            ${r.isDragging ? m`${e === 0 ? m`<div class="pin-zone pin-zone-left ${r.pinZone === "left" ? "active" : ""}"></div>` : g}
                  ${t === 0 ? m`<div class="pin-zone pin-zone-right ${r.pinZone === "right" ? "active" : ""}"></div>` : g}
                  ${r.willPin === "left" ? m`<div
                            class="pin-group-glow pin-group-glow-left active"
                            style="left: ${e}px"
                        ></div>` : g}
                  ${r.willPin === "right" ? m`<div
                            class="pin-group-glow pin-group-glow-right active"
                            style="right: ${t + n}px"
                        ></div>` : g}` : g}
        `;
	}
	render() {
		let { all: e, left: t, center: n, right: r } = this._columns.getGroupedColumns(), i = this._sort.getSortedData(this.rowData, u), a = [], o = 0, s = 0;
		for (let t of e) {
			let e = this._resize.getWidth(t);
			e == null ? t.minWidth == null ? a.push("1fr") : a.push(`minmax(${t.minWidth}px, 1fr)`) : a.push(`${e}px`);
			let n = e ?? t.minWidth ?? 0;
			t.pinned === "left" && (o += n), t.pinned === "right" && (s += n);
		}
		let c = this.native ? this._computeStickyLayout(t, r) : void 0;
		if (this.native) {
			o = 0, s = 0;
			for (let e of t) o += this._stickyWidths.get(l(e)) ?? 0;
			for (let e of r) s += this._stickyWidths.get(l(e)) ?? 0;
		}
		let d = (i, a) => this._renderRow(i, a, {
			all: e,
			left: t,
			center: n,
			right: r
		}, c), f = this.native ? g : `--ptc-ui-table-columns: ${a.join(" ")}`, p = m`
            <table part="table" style=${f}>
                ${this.native ? m`<colgroup>
                          ${e.map(() => m`<col />`)}
                      </colgroup>` : g}
                <thead>
                    <tr>
                        ${this.native ? e.map((e) => {
			let t = l(e);
			return this._renderHeaderCell(e, c?.offsets.get(t), c?.edgeField.has(t));
		}) : m`${this._renderHeaderPinnedGroup("left", t)}
                              ${n.map((e) => this._renderHeaderCell(e))}
                              ${this._renderHeaderPinnedGroup("right", r)}`}
                    </tr>
                </thead>
                ${this.virtualized ? m`<tbody>
                          ${V({
			scroller: !0,
			items: i,
			renderItem: d,
			layout: {
				direction: "vertical",
				...this.pinIndex >= 0 ? { pin: {
					index: this.pinIndex,
					block: "start"
				} } : {}
			}
		})}
                      </tbody>` : m`<tbody>
                          ${S(i, (e) => e[this.rowIdField], d)}
                      </tbody>`}
            </table>
        `;
		return m`
            ${this.native ? m`<div class="native-scroller">${p}</div>` : p}
            ${this._renderOverlays(o, s)}
        `;
	}
};
f([v({ type: Array }), d("design:type", Array)], Y.prototype, "columnDefs", void 0), f([v({ type: Array }), d("design:type", Array)], Y.prototype, "rowData", void 0), f([v({ type: Object }), d("design:type", Object)], Y.prototype, "virtualization", void 0), f([v({ type: Number }), d("design:type", Object)], Y.prototype, "headerHeight", void 0), f([v({ type: Boolean }), d("design:type", Object)], Y.prototype, "showBorders", void 0), f([v({ type: Boolean }), d("design:type", Object)], Y.prototype, "striped", void 0), f([v({ type: String }), d("design:type", Object)], Y.prototype, "rowIdField", void 0), f([v({ type: Number }), d("design:type", Object)], Y.prototype, "pinIndex", void 0), f([v({
	type: Boolean,
	reflect: !0
}), d("design:type", Object)], Y.prototype, "virtualized", void 0), f([v({
	type: Boolean,
	reflect: !0
}), d("design:type", Object)], Y.prototype, "native", void 0), f([v({
	type: Boolean,
	reflect: !0,
	attribute: "scroll-shadows"
}), d("design:type", Object)], Y.prototype, "scrollShadows", void 0), f([v({
	type: Boolean,
	reflect: !0,
	attribute: "highlight-row"
}), d("design:type", Object)], Y.prototype, "highlightRow", void 0), f([v({
	type: Boolean,
	reflect: !0,
	attribute: "highlight-column"
}), d("design:type", Object)], Y.prototype, "highlightColumn", void 0), f([v({
	type: Boolean,
	reflect: !0,
	attribute: "movable-columns"
}), d("design:type", Object)], Y.prototype, "movableColumns", void 0), f([v({ type: Array }), d("design:type", Array)], Y.prototype, "sortState", void 0), Y = f([_("ptc-ui-table")], Y);
export { Y as t };

//# sourceMappingURL=table-C4Pow47g.js.map